//Styles
import { Wrapper, Content } from "./Attribution.styles";

const Attribution = ({ movieTitle }) => (
    <Wrapper>
        <Content>
            <span>
                This product uses the TMDB API but is not endorsed or certified
                by TMDB.
            </span>
        </Content>
    </Wrapper>
);

export default Attribution;
